document.addEventListener('DOMContentLoaded', function () {
    const reveals = document.querySelectorAll('.reveal');

    const revealOnScroll = function () {
        const windowHeight = window.innerHeight;
        const elementVisible = 100;

        reveals.forEach((reveal) => {
            const elementTop = reveal.getBoundingClientRect().top;

            if (elementTop < windowHeight - elementVisible) {
                reveal.classList.add('active');
            }
        });
    };

    window.addEventListener('scroll', revealOnScroll);
    // Trigger once on load
    revealOnScroll();
});

function toggleMobileMenu() {
    const menu = document.querySelector('.mobile-menu');
    const overlay = document.querySelector('.mobile-menu-overlay');
    menu.classList.toggle('active');
    overlay.classList.toggle('active');

    // Prevent body scroll when menu is open
    if (menu.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
    }
}

function toggleMobileDropdown(button) {
    button.classList.toggle('open');
    const dropdownMenu = button.nextElementSibling;
    if (dropdownMenu) {
        dropdownMenu.classList.toggle('open');
    }
}

/**
 * Navigate to a URL/path while preserving the current page's query string (e.g. preview_theme_id in Shopify previews).
 * Accepts a relative path like "/products/handle" or an absolute URL.
 */
function navigatePreservingQuery(target) {
    try {
        const url = new URL(target, window.location.origin);
        // Preserve current query params (Shopify preview params) and hash.
        url.search = window.location.search || '';
        url.hash = window.location.hash || '';
        window.location.assign(url.toString());
    } catch (e) {
        // Fallback: best-effort append query string.
        const qs = window.location.search || '';
        window.location.assign(String(target) + qs);
    }
}

function toggleFilters() {
    const filters = document.querySelector('.filters');
    filters.classList.toggle('show-mobile');

    // Prevent body scroll when filters are open on mobile
    if (filters.classList.contains('show-mobile') && window.innerWidth <= 768) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
    }
}

// Collapsible Filter Groups
document.addEventListener('DOMContentLoaded', function () {
    const filterHeaders = document.querySelectorAll('.filter-group h4');

    // Initially collapse all filter groups ONLY on mobile
    if (window.innerWidth <= 768) {
        document.querySelectorAll('.filter-group').forEach(group => {
            group.classList.add('collapsed');
        });
    }

    filterHeaders.forEach(header => {
        header.addEventListener('click', function () {
            this.parentElement.classList.toggle('collapsed');
        });
    });
});

// Product Page: Image Gallery
function setProductMainImage(gallery, thumbnail, fallbackSrc) {
    const src = (thumbnail && thumbnail.dataset && thumbnail.dataset.mainImageSrc) || fallbackSrc;
    const srcset = thumbnail && thumbnail.dataset ? thumbnail.dataset.mainImageSrcset : '';
    const alt = thumbnail && thumbnail.dataset ? thumbnail.dataset.mainImageAlt : '';
    const width = thumbnail && thumbnail.dataset ? Number(thumbnail.dataset.mainImageWidth) : 0;
    const height = thumbnail && thumbnail.dataset ? Number(thumbnail.dataset.mainImageHeight) : 0;

    if (!src) return;

    const mainImage = gallery ? gallery.querySelector('.main-image img') : document.getElementById('mainImage');
    if (mainImage) {
        mainImage.src = src;
        if (srcset) {
            mainImage.srcset = srcset;
        } else {
            mainImage.removeAttribute('srcset');
        }
        if (alt) {
            mainImage.alt = alt;
        }
        if (width > 0) {
            mainImage.width = width;
        }
        if (height > 0) {
            mainImage.height = height;
        }
    }

    const thumbnails = gallery ? gallery.querySelectorAll('.thumbnail') : document.querySelectorAll('.thumbnail');
    thumbnails.forEach((thumb) => thumb.classList.remove('active'));
    if (thumbnail) thumbnail.classList.add('active');
}

function initProductImageGalleries() {
    document.querySelectorAll('.product-gallery').forEach((gallery) => {
        gallery.querySelectorAll('.thumbnail[data-main-image-src]').forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
                setProductMainImage(gallery, thumbnail);
            });

            thumbnail.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                setProductMainImage(gallery, thumbnail);
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', initProductImageGalleries);

function changeImage(thumbnail, src) {
    const gallery = thumbnail && thumbnail.closest ? thumbnail.closest('.product-gallery') : document.querySelector('.product-gallery');
    setProductMainImage(gallery, thumbnail, src);
}

// Product Page: Tabs
function openTab(tabId) {
    document.querySelectorAll('.tab-content').forEach(c => c.style.display = 'none');

    const tab = document.getElementById(tabId);
    if (tab) {
        tab.style.display = 'block';
    }

    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));

    // Check if event exists (triggered by click)
    if (typeof event !== 'undefined' && event.target) {
        event.target.classList.add('active');
    }
}
